module.exports = __webpack_public_path__ + "static/logo-27672a2115f7729439faf21f88834a95.png";